$(()=> {

  let chkVN = $('form').find('input[type=checkbox]');

  let btnVisanet = $('.start-js-btn');
  btnVisanet.hide();

  chkVN.on('change', (e)=> {
    let cantCKK = chkVN.length;
    let countValid = [];

    for ( let inp of chkVN ) {
      if ( $(inp).is(':checked') ) {
        countValid.push('true');
      }
    }

    if ( countValid.length == cantCKK ) {
      $('#btnSendVN').hide();
      btnVisanet.show();
    } else {
      $('#btnSendVN').show();
      btnVisanet.hide();
    }
  });
});
